<template>
  <basic-container>
    <div class="stockwrap">
      <div v-bind="stockData" class="stockMain" id="printBox">
        <h1 class="stockMain title" id="printTitle" style="font-weight: Medium;color:#333;">
          订单详情
        </h1>
        <div class="stockMain content" id="content">
          <table border style="width:100% ;text-align:left;">
            <tr>
              <th style="width:300px;font-weight: 600;">订单编号:</th>
              <th style="width:300px;">{{ stockData.orderNumber }}</th>
              <th style="width:300px;font-weight: 600;">出货时间:</th>
              <th style="width:300px">
                {{ handleFormatterDateToUTC(stockData.createTime) }}
              </th>
              <th style="width:300px;font-weight: 600;">商户名称:</th>
              <th style="width:300px">{{ stockData.shopName }}</th>
              <th style="width:300px;font-weight: 600;">商户电话:</th>
              <th style="width:300px">{{ stockData.account }}</th>
            </tr>
            <tr>
              
              <th style="width:300px;font-weight: 600;">商品数量共计:</th>
              <th style="width:300px">{{ stockData.total }}</th>
              <th style="width:300px;font-weight: 600;">商品总价:</th>
              <th style="width:300px">{{ stockData.totalAmount }}</th>
              <th style="width:300px;font-weight: 600;">收货信息:</th>
              <th style="width:300px">{{ stockData.contactsName+" "+stockData.mobile }}<br>{{ stockData.address}}</th>
              <th style="width:300px;font-weight: 600;">订单状态:</th>
              <th style="width:300px">{{ stockData.status}}</th>
            </tr>
            <tr v-if="stockData.providerShopName||stockData.providerAccount">
              <th style="width:450px;font-weight: 600;">配送商:</th>
              <th style="width:450px">{{ stockData.providerShopName }}</th>
              <th style="width:450px;font-weight: 600;">配送商电话:</th>
              <th style="width:450px">{{ stockData.providerAccount }}</th>
            </tr>
          </table>

          <h2 class="stockMain title" id="printTitle" style="font-weight: Medium;color:#333;">
           订单明细
          </h2>
          <el-table :data="tableData" border style="text-align: left;" :span-method="mergeRows">
            <el-table-column prop="goodsName" label="产品名称"></el-table-column>
            <!-- 产品图片 -->
            <el-table-column label="产品图片">
              <template slot-scope="scope">
                <img
                  :src="scope.row.img"
                  alt=""
                  style="width: 50px; height: 50px;"
                />
              </template>
            </el-table-column>
            <!-- 规格属性 -->
            <el-table-column prop="skuName" label="规格属性"></el-table-column>
            <el-table-column prop="price" label="商品单价"></el-table-column>
            <el-table-column prop="amount" label="数量"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </basic-container>
</template>

<script>
import { mapGetters } from "vuex";
import {
  findOrderDetail,
} from "@/api/salesCloud/agentOrderManagement";
import VueQr from "vue-qr";
import { formatterDateToUTC } from "@/util/util";
export default {
  name: "stockRemoval",
  components: {
    VueQr,
  },
  data() {
    return {
      tableData: [],
      tableLoading: false,
      tableHeaders: [],
      stockData: {},
    };
  },
  created() {
    let rowId = this.$route.query.id;
    this.dialogLook(rowId);
  },
  watch: {},
  mounted() {
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    handleFormatterDateToUTC(data) {
      return formatterDateToUTC(data);
    },
    dialogLook(rowId) {
      findOrderDetail(rowId).then((res) => {
        let data = JSON.parse(res.data);
        // 订单状态
        if (data.status == 'WAIT_PAY') {
          data.status = "待支付";
        } else if (data.status == 'WAIT_SHIPPED') {
          data.status = "待发货";
        } else if (data.status == 'IN_DELIVERY') {
          data.status = "配送中";
        } else if (data.status == 'FINISH') {
          data.status = "已完成";
        } 
        this.stockData = data;
        this.tableData = data.detail;
        this.tableLoading = false;
      });
    },
    mergeRows({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex > 0 && row.name === this.tableData[rowIndex - 1].name) {
          return {
            rowspan: 0,
            colspan: 0,
            display: 'none'
          };
        } else {
          let count = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].name === row.name) {
              count++;
            } else {
              break;
            }
          }
          return {
            rowspan: count,
            colspan: 1
          };
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.stockwrap {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .stockMain {
    height: 100%;

    .title {
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      margin: 20px 0;
    }

    .content {
      padding: 20px;

      table {
        border-collapse: collapse;
        border: 1px solid #ebeef5;

        th {
          border: 1px solid #ebeef5;
          padding: 10px;
        }

        td {
          border: 1px solid #ebeef5;
          padding: 10px;
        }
      }
    }
  }
}
</style>